(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-details-table"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-details-table')) {
    customElements.define('product-details-table', class extends HTMLElement {
      connectedCallback() {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.html.querySelector('product-info')?.dataset.productId) !== this.dataset.productId) return;
          const sku = data.variant?.sku || '';
          this.querySelector('[data-variant-sku]').textContent = sku;
          this.querySelector('[data-sku-row]').hidden = !sku;
          const code = this.querySelector('[data-product-code]').textContent;
          this.querySelector('[data-product-code-row]').hidden = !code || code === sku;
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-purchase-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-product-details-link]');
    if (!link) return;
    const details = document.getElementById(link.hash.slice(1));
    if (!details) return;
    event.preventDefault();
    details.open = true;
    details.scrollIntoView({ block: 'start', behavior: 'smooth' });
    details.querySelector('summary')?.focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

})();
